import React from 'react'
import * as PropTypes from 'prop-types'
import { Col, Divider, Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { customFields } from './CustomFieldsHelpers'

const CustomFieldsTypes = props => {
  const { fieldsData } = props

  const { t } = useTranslation()

  return (
    <>
      {fieldsData?.companyCustomFields?.length
        ? (
        <Divider>
          <Typography.Text className="blueTitle" strong>
            {t('settings.groups.customFields')}
          </Typography.Text>
        </Divider>
          )
        : null}
      <Row type="flex" gutter={18}>
        {fieldsData?.companyCustomFields?.map(field =>
          field
            ? (
            <Col md={8} xs={12} key={field.id}>
              {customFields(field.type, field.name, field.required, field.id, t)}
            </Col>
              )
            : null
        )}
      </Row>
    </>
  )
}

CustomFieldsTypes.propTypes = {
  fieldsData: PropTypes.object.isRequired
}

export default CustomFieldsTypes
